import HTTP from '@/http-common.js'

const HandleImageAdded = {
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('file', file)

      HTTP.post('upload', formData)
        .then((response) => {
          let url = response.data.thumbnail_urls.original
          Editor.insertEmbed(cursorLocation, 'image', url)
          resetUploader()
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}

export default HandleImageAdded
